import { InstoreOrderLineCustomField } from "../models/instoreOrder";

const normalizeCustomFields = (
  input: Record<string, string> | string[] | InstoreOrderLineCustomField[] | undefined
): InstoreOrderLineCustomField[] => {
  if (!input) return [];

  if (Array.isArray(input)) {
    // input is string[] => convert to { fieldName, fieldValue: "" }
    if (typeof input[0] === "string") {
      return (input as string[]).map((key) => ({
        fieldName: key,
        fieldValue: "",
      }));
    }

    // input is InstoreOrderLineCustomField[] => return as-is
    return input as InstoreOrderLineCustomField[];
  }

  // input is Record<string,string> => convert to { fieldName, fieldValue }
  return Object.entries(input).map(([key, value]) => ({
    fieldName: key,
    fieldValue: value,
  }));
};

export default normalizeCustomFields;